import http from "./main";

export default {
    getAll: async () => {
        return await http.get("/locations");
    }
}